import React from 'react';

const DevModeIndicator: React.FC = () => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const style: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: '#ff4444',
    color: 'white',
    padding: '4px 8px',
    fontSize: '12px',
    zIndex: 9999,
  };

  return (
    <div style={style}>
      DEV MODE - Telegram WebApp Mock Active
    </div>
  );
};

export default DevModeIndicator; 